import { useState } from 'react';
import isEmpty from 'lodash/isEmpty';
import { useDeepCompareEffect } from 'use-deep-compare';
import { jsonataWithCallback } from '../expressions/expressions';
import { ViewRenderer } from './DashboardViewer';
import { logger } from '../../utils';

export const ElementMap = ({ array = [], render = 'function($i) {$i}' }) => {
  const [view, setView] = useState([]);
  useDeepCompareEffect(() => {
    const computeView = async () => {
      const jsonataExpression = `$map($, ${render})[]`;
      try {
        logger.log('Each input', array, render);
        const out = await jsonataWithCallback(jsonataExpression, array);
        logger.log('Each evaluatedView', out);
        setView(out as unknown as React.SetStateAction<never[]>);
      } catch (error) {
        logger.error('Each error evaluating', array, render, error);
      }
    };
    computeView();
  }, [array, render, setView]);

  if (isEmpty(view)) {
    return null;
  }

  return <ViewRenderer view={view} name="iMap" />;
};
